import { participantNoteName } from '@seen/core/models/noteName'
import type { ParticipantNote } from '@seen/core/models/participantNote'
import { useMemo } from 'react'
import { browserNoteText } from '#src/utils/noteDisplay.ts'

/* Pure (non-hook) equivalent of `useParticipantNoteTitle`. Extracted so
 * callers outside a React render phase (e.g., MiniSearch field
 * extractors) can derive the same title without violating the rules of
 * hooks. The rule itself is `participantNoteName` in `@seen/core`. */
export function getParticipantNoteTitle(
  participantNote: ParticipantNote | undefined | null
): string {
  return participantNoteName(participantNote, browserNoteText)
}

/* Orbit-native notes title off their first content line, NOT the AI-generated
 * `aiTitle` (which stays for Elation notes only). The first line is the note's
 * own heading, so it stays stable and recognizable; the AI title is still
 * surfaced as the row summary. */
export function useParticipantNoteTitle(
  participantNote: ParticipantNote | undefined | null
): string {
  const content = participantNote?.content
  return useMemo(
    () => participantNoteName({ content }, browserNoteText),
    [content]
  )
}
